import { jsx as _jsx } from "react/jsx-runtime";
import UploadPhotosView from './UploadPhotos.view';
const UploadPhotos = () => {
    return _jsx(UploadPhotosView, {});
};
export default UploadPhotos;
